import { Colors } from '@nakedplatform/ui';

/**
 * Loads the peach options into window and sets the styling for the components.
 */
export const loadPeachOptions = () => {
  window.wpwlOptions = {
    style: 'plain',
    // eslint-disable-next-line no-console
    onError: console.log,
    onReady: () => {
      const { $ } = window;
      const { checkoutText } = window;
      const base = $('.wpwl-form');
      const $row = $('<div class="cvv-expiry"></div>');
      const $cvvField = base.find('.wpwl-group-cvv').addClass('column small-6');
      const $expiryField = base.find('.wpwl-group-expiry').addClass('column small-6');

      base.find('.wpwl-control-cardHolder').attr('placeholder', 'Name on card');
      base.find('.wpwl-control-cardNumber').attr('placeholder', 'Card number');
      base.find('.wpwl-group-cvv, .wpwl-group-expiry').remove();
      $row.append($expiryField).append($cvvField);
      $('.wpwl-group-cardNumber').after($('.wpwl-group-cardHolder'));
      $('.wpwl-group-cardHolder').after($row);
      $('.wpwl-button-pay').html(checkoutText);

      $('.wpwl-group.wpwl-group-cardNumber .wpwl-wrapper-cardNumber').append(
        $('<div class="brand-container"></div>').append($('.wpwl-brand:first'))
      );
    },
    showCVVHint: true,
    brandDetection: true,
    onAfterSubmit: () => {
      /** This is left open because we don't do anything after submitting. */
    },
    iframeStyles: {
      'card-number-placeholder': {
        color: Colors.darkGrey,
      },
      'cvv-placeholder': {
        color: Colors.darkGrey,
      },
    },
    onFocusIframeCommunication() {
      this.$iframe[0].style.borderColor = Colors.green;
    },
  };
  global.wpwlOptions = window.wpwlOptions;
};
